module.exports = __webpack_public_path__ + "img/day_ezn.85474cd9.gif";